import React from 'react';
import './Switch.css'; // We'll create this CSS file next

const Switch = ({ isOn, handleToggle, disabled = false }) => {
  return (
    <label className="switch-label">
      <input
        type="checkbox"
        checked={isOn}
        onChange={handleToggle}
        className="switch-checkbox"
        disabled={disabled}
      />
      <span className="switch-button" />
    </label>
  );
};

export default Switch;